<div class="landing_wrap">
    <app-main-navbar></app-main-navbar>
    <app-parent-intro></app-parent-intro>
    <app-footer></app-footer>
</div>